import moment from 'moment';
import EventIcon from 'apps/events/components/event-icon';
import EventbriteDetailResolver from 'apps/events/components/eventbrite-detail-resolver';
import EllipsisOverflow from 'components/formatting/ellipsis-overflow';
import { Link } from '@evertrue/et-components';

const EventsTableConfig = [
  {
    field: 'event',
    headerName: 'Event',
    minWidth: 580,
    flex: 1,
    sortable: true,
    hideable: false,
    renderCell: ({ row }) => {
      const event = row.rawEvent;
      return (
        <div>
          <EventIcon className="events-table--picture" event={event} size={60} />
          <div className="events-table--text">
            <Link href={`events/${event.id}`} title={`${event.name} page`} className="emphasis">
              <EllipsisOverflow>{event.name}</EllipsisOverflow>
            </Link>
            {event.page_name && <EllipsisOverflow>by {event.page_name}</EllipsisOverflow>}
          </div>
        </div>
      );
    },
  },
  {
    field: 'date',
    headerName: 'Event Date',
    flex: 1,
    sortable: true,
    renderCell: ({ row }) => {
      const event = row.rawEvent;
      const time = moment(event.start_time);
      return (
        <div>
          <div>{time.format('MM/D/YYYY')}</div>
          <div>{time.format('h:mm A')}</div>
        </div>
      );
    },
  },
  {
    field: 'location',
    headerName: 'Event Location',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      const loc = row.rawEvent.location || {};
      return (
        <div className="events-table--location">
          {loc.name || '-'}
          {loc.street && <div>{loc.street}</div>}
          {loc.city && loc.state && loc.zip && (
            <div>
              {loc.city}, {loc.state} {loc.zip}
            </div>
          )}
        </div>
      );
    },
  },
  {
    field: 'matched_count',
    headerName: 'Matched Engagers',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      const event = row.rawEvent;
      if (event.source === 'eventbrite') {
        return (
          <EventbriteDetailResolver
            event={event}
            include_unmatched={false}
            include_filters={false}
            render={({ matchedCounts }) => (
              <div>
                <span>{matchedCounts ? matchedCounts.all : <span className="text-muted">~</span>}</span>
              </div>
            )}
          />
        );
      }
      const count = event._matched_engagers_count;
      return (
        <div>
          <span>{count != null ? count : <span className="text-muted">~</span>}</span>
        </div>
      );
    },
  },
  {
    field: 'unmatched_count',
    headerName: 'Unmatched Engagers',
    flex: 1,
    sortable: false,
    renderCell: ({ row }) => {
      const event = row.rawEvent;
      if (event.source === 'eventbrite') {
        return (
          <EventbriteDetailResolver
            event={event}
            include_matched={false}
            include_filters={false}
            render={({ unmatchedCounts }) => (
              <div>
                <span>{unmatchedCounts ? unmatchedCounts.all : <span className="text-muted">~</span>}</span>
              </div>
            )}
          />
        );
      }

      return (
        <div>
          <span>
            <span className="text-muted">~</span>
          </span>
        </div>
      );
    },
  },
];

export default EventsTableConfig;
